import { Label, LoadingSpinner } from '@shared/ui';
import { commaThousondSeperator, formatFaNumber } from '@shared/lib';
import { TUserAsset } from '@entities/investments';

import { goldAssetsLanguages, goldTrade } from '../model';
import { TGoldLastPriceResponse } from '../api';

type TGoldAssetsProps = {
  livePrice: {
    data: TGoldLastPriceResponse | undefined;
    isFetching: boolean;
    isError: boolean;
  };
  goldAsset: {
    goldAssetsData: TUserAsset | undefined;
    goldAssetsIsError: boolean;
    goldAssetsIsFetching: boolean;
  };
  onSelectRialValue?: (value: number) => void;
};

export const GoldAssets = ({
  livePrice,
  goldAsset,
  onSelectRialValue,
}: TGoldAssetsProps) => {
  const handleSelectValue = () => {
    if (onSelectRialValue && goldAsset.goldAssetsData?.value) {
      onSelectRialValue(goldAsset.goldAssetsData.value);
    }
  };

  return (
    <div className='flex flex-col gap-5 bg-hover w-full md:w-[450px] rounded-2xl p-4 mb-5 md:mx-3'>
      <div className=' flex flex-row justify-between items-center mx-1'>
        <Label className='body-13-regular text-icons'>{goldTrade.CurrentPrice24gold}</Label>
        <p className='h5-bold flex flex-row'>
          {livePrice.isFetching ? (
            <LoadingSpinner className='scale-50' />
          ) : livePrice?.data?.price ? (
            commaThousondSeperator(livePrice?.data?.price * 1000)
          ) : (
            '-'
          )}
          <span className='pr-1'>{goldAssetsLanguages.rial}</span>
        </p>
      </div>
      {goldAsset.goldAssetsData?.value ? (
        <div className='flex flex-col md:flex-row justify-start md:justify-around rounded-2xl p-3 md:p-5 bg-background'>
          <div className='flex flex-row md:flex-col gap-2 items-center justify-between md:justify-center'>
            <p className='body-13-regular text-icons'> {goldAssetsLanguages.rialValue}</p>
            <p
              className={`h6-bold md:h5-bold ${onSelectRialValue ? 'cursor-pointer' : ''}`}
              onClick={handleSelectValue}
            >
              {goldAsset.goldAssetsData?.value
                ? commaThousondSeperator(goldAsset.goldAssetsData?.value)
                : '-'}
              <span className='mr-1 body-11-regular'>{goldAssetsLanguages.rial}</span>
            </p>
          </div>
          <div className='flex flex-row md:flex-col gap-2 items-center justify-between md:justify-center'>
            <p className='body-13-regular text-icons'>{goldAssetsLanguages.goldValue}</p>
            <p
              className={`h6-bold md:h5-bold ${onSelectRialValue ? 'cursor-pointer' : ''}`}
              onClick={handleSelectValue}
            >
              {formatFaNumber(goldAsset.goldAssetsData?.volume)}
              <span className='mr-1 body-11-regular'>{goldAssetsLanguages.miliGeram}</span>
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
